var module = angular.module('octopusApp.shared');

module.controller('AddIdentityController', function ($scope, busy, $uibModalInstance, octopusClient, octopusRepository, metadata) {

    var isLoading = $scope.isLoading = busy.create();
    
    var providers = octopusClient.rootDocument().AuthenticationProviders;

    $scope.enabledIdentityProviders = _.filter(metadata.Providers, function (p) { return _.some(providers, function (a) { return a.Name === p.IdentityProviderName}); });

    var claimFromDescriptor = function(descriptor) {
        var claim = { 
            Value: '',
            IsIdentifyingClaim: descriptor.IsIdentifyingClaim
        };
        return claim;
    }

    $scope.createIdentity = function() {
        var identity = {
            IdentityProviderName: $scope.selectedProvider.IdentityProviderName,
            Claims: {}
        };

        _.each($scope.selectedProvider.ClaimDescriptors, function (d) { identity.Claims[d.Type] = claimFromDescriptor(d); });

        return identity;
    }

    $scope.$watch('providerName', function(newVal, oldVal) {
        console.log('provider changed to ' + newVal);

        $scope.selectedProvider = _.find($scope.enabledIdentityProviders, function (p) { return p.IdentityProviderName === $scope.providerName; });
        $scope.showSearch = $scope.selectedProvider && _.some($scope.selectedProvider.Links, function (value, key) { return key == 'UserLookup'; });

        if (!$scope.selectedProvider)
            return;

        if ($scope.showSearch) {
            console.log('show search');
            $scope.identity = null;

        } else {
            console.log('allow editing');
            $scope.identity = $scope.createIdentity();
        }
    });

    $scope.MapClaimLabel = function(key) {
        var v = _.find($scope.selectedProvider.ClaimDescriptors, function (d) { return d.Type == key; });
        return v.Label;
    }

    $scope.MapClaimDescription = function(key) {
        var v = _.find($scope.selectedProvider.ClaimDescriptors, function (d) { return d.Type == key; });
        return v.Description;
    }

    $scope.search = {
        partialName: "",

        hasSearched: false,
        hasResults: false,

        perform: function() {
            var uri = _.find($scope.selectedProvider.Links, function (value, key) { return key == 'UserLookup'; });
            isLoading.promise(octopusRepository.ExternalUsers.searchProvider(uri, $scope.search.partialName).then(function (results) {
                $scope.search.results = results.Identities;
                $scope.search.hasSearched = true;
                $scope.search.hasResults = results.Identities.length > 0;
            }));
        }
    };

    $scope.showSave = function() {
        return !$scope.showSearch && $scope.identity;
    }

    $scope.canSave = function() {
        return !$scope.showSearch && $scope.identity && _.some($scope.identity.Claims, function (c) { return c.IsIdentifyingClaim && c.Value;});
    }

    $scope.select = function (identity) {
        $uibModalInstance.close(identity);
    }

    $scope.save = function () {
        $uibModalInstance.close($scope.identity);
    };

    $scope.cancel = function () {
        $uibModalInstance.close();
    };
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/controllers/add_identity_controller.js
// module id = 6931028032198674
// module chunks = 1